import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CLIENT_ID, REDIRECT_URL } from '../../../configurations/config';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  clientId: string | null = null;

  constructor(private router: Router, private authService: AuthService, private route: ActivatedRoute, private spinner: NgxSpinnerService
  ) {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      this.clientId = params['client_id'];

      if (this.clientId == null || this.clientId == undefined || this.clientId == '')
        this.clientId = this.authService.getClienteIdLocal();

      if (this.clientId)
        this.authService.setClienteIdLocal(this.clientId);

      if (code && this.clientId) {
        this.spinner.show()
        const id = this.authService.verificaClientId(this.clientId);
        this.authService.exchangeCodeForToken(code, id).subscribe({

          next: (response) => {
            const redirectUrl = response.redirectUrl;
            if (redirectUrl) {
              this.spinner.hide();
              window.location.href = redirectUrl;
            } else {
              console.error('URL de redirecionamento não encontrada');
              this.spinner.hide();
            }
          },
          error: (err) => {
            console.error('Erro ao trocar código por token:', err);
            this.spinner.hide();
          }
        });
      }
    })
  }

  goTo(path: string) {
    this.router.navigate([path]);
  }

  loginWithGoogle() {
    const clientId = CLIENT_ID;
    const redirectUri = encodeURIComponent(REDIRECT_URL);
    const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=openid%20email%20profile`;

    window.location.href = googleAuthUrl;
  }
}
